import React, { Component } from 'react'

import ServiceOrderView from './ServiceOrderView'

class ServiceOrderEditor extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <ServiceOrderView {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceOrderEditor



// WEBPACK FOOTER //
// ./src/components/service_order/ServiceOrderEditor.js